const CenteredLoadingSpinner = () => {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <img src="/images/ellipsis-3s-90px/Ellipsis-3s-90px.svg" alt="Loading..." style={{ maxWidth: 100 }} />
    </div>
  );
};

export default CenteredLoadingSpinner;
